import mapperIcon from '../../utils/mappers/mapper-icon'
import { mapperModuleNavigationLink } from '../../modules/module-navigation-link/mapper-module-navigation-link'

/**
 * globalDataChannel, normalize Global Data - channel
 * @param {Object} data - cms response data
 * @param {getUrl} getUrl - returns the url
 * @return {Object} the normalized data
 */

export default (data: any, getUrl: Function) => {
  if (!data) {
    return null
  }
  return {
    id: data?.sys?.id || '',
    name: data?.name || '',
    icon: mapperIcon(data?.icon),
    link: data?.link ? mapperModuleNavigationLink(data.link, getUrl) : null
  }
}
